module.exports = __webpack_public_path__ + "img/link.408aaff7.png";